export default __webpack_public_path__ + "static/icon_bpr-4dcafcb97b6ce7f9fbd00d1a8e0cfb28.png";